// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notifications-popover-container {
  width: 252px;
}
.notifications-popover-container .deck-notifications-header {
  display: flex;
  align-items: center;
  padding: 0;
}
.notifications-popover-container .deck-notifications-header h3 {
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
}
.notifications-popover-container .deck-notifications-header button {
  margin-left: auto;
  padding: 6px 8px;
  border: none;
  border-radius: 22px;
}
.notifications-popover-container .deck-notifications-filters {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px;
}
.notifications-popover-container .deck-notifications-filters button {
  padding: 5px 13px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  border-radius: 22px;
  border: none;
  background: transparent;
}
.notifications-popover-container .deck-notifications-filters button.active {
  background: #F5F7FA;
}
.notifications-popover-container .deck-notifications-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.notifications-popover-container .deck-notifications-list .inactive {
  color: #747474 !important;
}
.notifications-popover-container .deck-notifications-list .inactive .deck-notifications-content * {
  color: #747474 !important;
}
.notifications-popover-container .deck-notifications-list .last-item {
  position: relative;
  width: 1px;
  height: 1px;
  overflow: hidden;
}
.notifications-popover-container .deck-notifications-content-outer {
  margin-right: 26px;
  color: black;
}
.notifications-popover-container .deck-notifications-content {
  margin-bottom: 8px;
}
.notifications-popover-container .deck-notifications-content p {
  margin-bottom: 8px;
}
.notifications-popover-container .deck-single-notification-more {
  float: right;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}
.notifications-popover-container .deck-notifications-item-meta {
  margin-bottom: 22px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
}
.notifications-popover-container .deck-notifications-options-menu-outer .ant-popover-content {
  min-width: 279px;
}
.notifications-popover-container .deck-notifications-options-menu {
  padding: 16px 10px;
  list-style-type: none;
}
.notifications-popover-container .deck-notifications-options-menu li {
  padding: 8px;
}
.notifications-popover-container .deck-notifications-options-menu button {
  padding: 0;
  border: none;
  background: transparent;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  color: #444A53;
  cursor: pointer;
}
.notifications-popover-container .deck-notifications-options-menu button span {
  pointer-events: none;
}
.notifications-popover-container .deck-notifications-options-menu .nkl-deck-icon {
  margin-right: 14px;
}
.notifications-popover-container .deck-notifications-empty {
  text-align: center;
}
.notifications-popover-container .deck-notifications-empty img {
  width: 144px;
  margin: 72px 0 32px 0;
}
.notifications-popover-container .deck-notifications-empty h4 {
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  color: #444a53;
}
.notifications-popover-container .deck-notifications-empty p {
  font-size: 16px;
  line-height: 26px;
  font-weight: 300;
  color: rgba(68, 74, 83, 0.7);
}
.notifications-popover-container .deck-notifications-empty p:last-child {
  margin-bottom: 72px;
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
